module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LlEh7k/tc-custom/9780811744010.jpg?1728155782023",
      "alt": "This image is the cover for the book Walking the Appalachian Trail"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Walking the Appalachian Trail\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A fascinating portrait of the community of people—and one cat—who’ve traveled the trail end to end, by the founder of the Appalachian Trail Museum.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Countless hikers have walked stretches of the two-thousand-plus-mile Appalachian Trail, but only a small, deeply dedicated group has completed the trek all the way through from Georgia to Maine. This book explores the history of the trail through colorful profiles of those who are a part of this unique community and reveals the customs and culture that have evolved around them over the years."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From the sore muscles to the moments of solitude in nature, from the retired postmaster who parachuted onto the top of Springer Mountain to begin his journey to the woman who set out in tennis shoes because she couldn’t find women’s hiking boots in her size, "), _c('i', [_vm._v("Walking the Appalachian Trail")]), _vm._v(" explores questions of who these end-to-enders are, what drives them, what risks they face, and what rewards to body and soul they gain from this extraordinary walk. "), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Includes color photographs")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Larry Luxenberg, Mike Warren, Maurice J Forrester\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Stackpole Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0